import { reactive } from 'vue'

// 创建一个响应式状态存储loading信息
const state = reactive({
  visible: false,
  text: 'loading...',
  loadingCount: 0
})

// 导出loading服务
export const loadingService = {
  // 显示loading
  show(text = 'loading...') {
    state.loadingCount++
    state.visible = true
    state.text = text
  },
  
  // 隐藏loading
  hide() {
    if (state.loadingCount > 0) {
      state.loadingCount--
    }
    
    if (state.loadingCount === 0) {
      state.visible = false
      state.text = ''
    }
  },
  
  // 获取当前状态
  getState() {
    return state
  }
} 